import React from "react";
import { Column } from "devextreme-react/data-grid";
import { LVGridDetalle } from "../../Componentes/Basicos/LVGridDetalle";
import { TextArea } from "devextreme-react";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import {
  function_VEN_DocsVenta_Cabecera_Clonar, function_VEN_DocsVenta_Cabecera_ClonarConIncremento,
  function_VEN_DocsVenta_Cabecera_GenerarNC, function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE
} from "neftis7_apicaller/src/funciones/VEN/DocsVenta/VEN_DocsVenta_Cabecera";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";

class VEN_DocsVenta_Detalle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      globalUsaArticulosConPresentacion: true,
      globalUsaArticulosConTamano: true,
      globalUsaArticulosConUnidadDeMedida: true,
      validandoARCA: false,
    };
  }

  getData = async (IdClave) => {
    // Llama a función asíncrona y maneja los datos
    try {
      const { VEN_DocsVenta_Cabecera: { function_VEN_DocsVenta_Cabecera_Leer } } = require('neftis7_apicaller');
      const resultData = await function_VEN_DocsVenta_Cabecera_Leer(IdClave);
      this.setState({ data: resultData.data, loading: false });
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    this.setState({ loading: false });
  };

  getDataParametros = async () => {
    try {
      const { Varios: { TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
      const { Varios: { ObtieneParametros } } = require('neftis7_apicaller');
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      this.state.globalUsaArticulosConPresentacion = globalUsaArticulosConPresentacionLocal
      this.state.globalUsaArticulosConTamano = globalUsaArticulosConTamanoLocal
      this.state.globalUsaArticulosConUnidadDeMedida = globalUsaArticulosConUnidadDeMedidaLocal

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  componentDidMount = async () => {
    this.getData(this.props.data.data.IdDocVenta)
    this.getDataParametros()
  };

  handleOnClickClonar = async () => {
    try {
      const IdDocVenta = this.props.data.data.IdDocVenta
      const FechaDoc = new Date()

      const dia = FechaDoc.getDate();
      const mes = FechaDoc.getMonth();
      const anio = FechaDoc.getFullYear();

      const FechaDocVencimiento = new Date(anio, dia < 10 ? mes : mes + 1, 10);

      const DocVentaNuevo = await function_VEN_DocsVenta_Cabecera_Clonar(IdDocVenta,
        localStorage.getItem("IdPersona"), FormateoFechaPara_yyyyMMdd(FechaDoc), FormateoFechaPara_yyyyMMdd(FechaDocVencimiento))

      alert("Se ha generado el Documento de Venta Nº: " + DocVentaNuevo.data.codigoGenerado);
    } catch (error) {
      alert("Error al clonar Documento de Venta:" + error);
    }
  }

  handleOnClickClonarConIncremento = async () => {
    try {
      const IdDocVenta = this.props.data.data.IdDocVenta
      const FechaDoc = new Date()

      const dia = FechaDoc.getDate();
      const mes = FechaDoc.getMonth();
      const anio = FechaDoc.getFullYear();

      const FechaDocVencimiento = new Date(anio, dia < 10 ? mes : mes + 1, 10);

      let IncrementoEnPorcentaje = prompt("Ingrese el incremento en porcentaje:", "0");

      // Convertirlo a número y validar
      IncrementoEnPorcentaje = parseFloat(IncrementoEnPorcentaje);

      const DocVentaNuevo = await function_VEN_DocsVenta_Cabecera_ClonarConIncremento(IdDocVenta,
        localStorage.getItem("IdPersona"), FormateoFechaPara_yyyyMMdd(FechaDoc), FormateoFechaPara_yyyyMMdd(FechaDocVencimiento), IncrementoEnPorcentaje)

      alert("Se ha generado el Documento de Venta Nº: " + DocVentaNuevo.data.codigoGenerado);
    } catch (error) {
      alert("Error al clonar Documento de Venta:" + error);
    }
  }

  handleOnClickGenerarNC = async () => {
    try {
      const IdDocVenta = this.props.data.data.IdDocVenta
      const FechaDoc = new Date()

      const dia = FechaDoc.getDate();
      const mes = FechaDoc.getMonth();
      const anio = FechaDoc.getFullYear();

      const FechaDocVencimiento = new Date(anio, dia < 10 ? mes : mes + 1, 10);

      const DocVentaNuevo = await function_VEN_DocsVenta_Cabecera_GenerarNC(IdDocVenta,
        localStorage.getItem("IdPersona"), FormateoFechaPara_yyyyMMdd(FechaDoc), FormateoFechaPara_yyyyMMdd(FechaDocVencimiento))

      alert("Se ha generado el Documento de Venta Nº: " + DocVentaNuevo.data.codigoGenerado);
    } catch (error) {
      alert("Error al clonar Documento de Venta:" + error);
    }
  }

  handleOnClickValidacionARCA = async () => {
    try {
      this.setState({ validandoARCA: true }); 
  
      const IdDocVenta = this.props.data.data.IdDocVenta

      await function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE(IdDocVenta)

      alert("Se ha validado el Documento de Venta");

      await this.getData(this.props.data.data.IdDocVenta)
    } catch (error) {
      console.log(error)
      alert("Error al validar Documento de Venta" + error);
    } finally {
      this.setState({ validandoARCA: false }); 
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loadingItems ? null : (
          <div style={{ display: "flex", gap: "20px" }}>
            {this.state.data && this.state.data.Detalles && this.state.data.Detalles.length > 0 ? (
              <div style={{ flex: 1 }}>
                <LVGridDetalle
                  dataSource={this.state.data.Detalles}
                  Titulo="Items"
                >
                  <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />
                  <Column caption="Artículo" alignment="Center">
                    <Column caption="Código" dataField="CodigoArticulo" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Observaciones" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Presentación" alignment="Center" visible={this.state.globalUsaArticulosConPresentacion}>
                    <Column caption="Código" dataField="CodigoPresentacion" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_ART_Presentaciones_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Tamaño" alignment="Center" visible={this.state.globalUsaArticulosConTamano}>
                    <Column caption="Código" dataField="CodigoTamano" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_ART_Tamanos_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Unidad de Medida" alignment="Center" visible={this.state.globalUsaArticulosConUnidadDeMedida}>
                    <Column caption="Código" dataField="CodigoUnidadMedida" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_ART_UnidadesMedida_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>

                  <Column caption="Cantidades" alignment="Center">
                    <Column caption="Pedida" dataField="CantidadPedida" width="70" alignment="Right" dataType="number" />
                    <Column caption="Facturada" dataField="Cantidad" width="70" alignment="Right" dataType="number" />
                    <Column caption="Remitida" dataField="CantidadRemitida" width="70" alignment="Right" dataType="number" />
                  </Column>

                  <Column caption="Importes" alignment="Center">
                    <Column caption="Neto" dataField="ImporteNeto" width="100" alignment="Right" dataType="number" format="currency" />
                    <Column caption="I.V.A." dataField="ImporteIVA" width="100" alignment="Right" dataType="number" format="currency" />
                    <Column caption="Descuentos" dataField="ImporteDescuentos" width="100" alignment="Right" dataType="number" format="currency" />
                    <Column caption="Recargos" dataField="ImporteRecargos" width="100" alignment="Right" dataType="number" format="currency" />
                  </Column>

                  <Column caption="Ubicación" alignment="Center">
                    <Column caption="Código" dataField="CodigoUbicacionIngreso" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_ZON_Ubicaciones_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>
                </LVGridDetalle>

                <br />

                {this.state.loadingImpuestos ? null : (
                  <>
                    {this.state.data && this.state.data.Impuestos && this.state.data.Impuestos.length > 0 ? (
                      <>
                        <LVGridDetalle
                          dataSource={this.state.data.Impuestos}
                          Titulo="Impuestos"
                        >
                          <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />
                          <Column caption="Impuesto" alignment="Center">
                            <Column caption="Código" dataField="CodigoImpuestoTipo" width="70" alignment="Left" dataType="string" />
                            <Column caption="Descripción" dataField="Descripcion" width="200" alignment="Left" dataType="string" />
                          </Column>
                          <Column caption="Neto" dataField="ImporteImpuesto" width="100" alignment="Right" dataType="number" format="currency" />
                          <Column caption="Porcentaje" dataField="Porcentaje" width="100" alignment="Right" dataType="number" />
                          <Column caption="Comprobante" dataField="Comprobante" width="200" alignment="Left" dataType="string" />
                        </LVGridDetalle>
                      </>
                    ) : null}
                  </>
                )}
              </div>
            ) : null}

            <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "20px" }}>
              {this.state.data && this.state.data.RelacionesDocsVentaPedidosResult && this.state.data.RelacionesDocsVentaPedidosResult.length > 0 ? (

                <LVGridDetalle
                  dataSource={this.state.data.RelacionesDocsVentaPedidosResult}
                  Titulo="Pedidos"
                >
                  <Column caption="Código" dataField="IdPedido" width="80" alignment="Right" dataType="number" />
                </LVGridDetalle>
              ) : null}

              {this.state.data && this.state.data.RelacionesDocsVentaRemitosResult && this.state.data.RelacionesDocsVentaRemitosResult.length > 0 ? (

                <LVGridDetalle
                  dataSource={this.state.data.RelacionesDocsVentaRemitosResult}
                  Titulo="Remitos"
                >
                  <Column caption="Código" dataField="IdRemito" width="80" alignment="Right" dataType="number" />
                  <Column caption="Documento" dataField="NumeroFantasia" width="120" alignment="Left" dataType="string" />
                </LVGridDetalle>

              ) : null}

              {this.state.data && this.state.data.Concepto ? (
                <>
                  <span style={{ fontWeight: "bold" }}>Concepto</span>
                  <TextArea defaultValue={this.state.data.Concepto} width={200} readOnly={true} />
                </>
              ) : null}

              {this.state.data && this.state.data.Observaciones ? (
                <>
                  <span style={{ fontWeight: "bold" }}>Observaciones</span>
                  <TextArea defaultValue={this.state.data.Observaciones} width={200} readOnly={true} />
                </>
              ) : null}

              <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "10px", width: "250px" }}>
                <LVButtonAccion Texto={"CLONAR"} onClick={this.handleOnClickClonar} />
                <LVButtonAccion Texto={"CLONAR CON INCREMENTO"} onClick={this.handleOnClickClonarConIncremento} />
                <LVButtonAccion Texto={"NOTA DE CRÉDITO"} onClick={this.handleOnClickGenerarNC} />
                <LVButtonAccion onClick={this.handleOnClickValidacionARCA}
                 Texto={this.state.validandoARCA ? "VALIDANDO..." : "VALIDACIÓN ARCA"}                  
                 disabled={this.state.validandoARCA} />
              </div>
            </div>
          </div>
        )
        }
      </React.Fragment>
    );
  }
}

export default VEN_DocsVenta_Detalle;
